import { createSlice } from '@reduxjs/toolkit';
import type { TopicSuggestionState } from './types';

const initialState: TopicSuggestionState = {
  isLoading: false,
  error: false,
  suggestedTopics: [],
  mySuggestedTopics: [],
  aiSuggestions: null,
  aiSuggestionsLoading: false,
  aiSuggestionsError: null
};

export const slice = createSlice({
  name: 'topicSuggestion',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    suggestedTopicsSuccess(state, action) {
      state.suggestedTopics = action.payload;
    },
    acceptSuggestedTopicSuccess(state, action) {
      state.suggestedTopics = state.suggestedTopics.filter(
        (topic) => topic.guid !== action.payload
      );
    },
    rejectSuggestedTopicSuccess(state, action) {
      state.suggestedTopics = state.suggestedTopics.filter(
        (topic) => topic.guid !== action.payload
      );
    },
    mySuggestedTopicsSuccess(state, action) {
      state.mySuggestedTopics = action.payload;
    },
    aiSuggestionsStart(state) {
      state.aiSuggestionsLoading = true;
      state.aiSuggestionsError = null;
    },
    aiSuggestionsSuccess(state, action) {
      state.aiSuggestionsLoading = false;
      state.aiSuggestions = action.payload;
      state.aiSuggestionsError = null;
    },
    aiSuggestionsFailure(state, action) {
      state.aiSuggestionsLoading = false;
      state.aiSuggestionsError = action.payload ?? 'Failed to get AI suggestions';
    },
    aiSuggestionsClear(state) {
      state.aiSuggestions = null;
      state.aiSuggestionsError = null;
    }
  }
});

export default slice.reducer;
